import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { GeneralEnum, LecturePriorityEnum, LectureStatusEnum, LectureTypeEnum } from 'src/app/submit-lecture/lecture.values';
import { ILecture } from 'src/app/views/pages/lectures/lecture.interface';
import { LecturesService } from 'src/app/views/pages/lectures/lectures.service';
import { ActionTypeEnum } from '../../../../audit-log/action-type.enum';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';
@Component({
  selector: 'cell-actions',
  templateUrl: './cell-actions.component.html',
  styleUrls: ['./cell-actions.component.scss'],
})

export class CellActionsComponent implements ICellRendererAngularComp {
  refresh;
  private params: any;
  constructor(
    private readonly translate: TranslateService,
    private readonly lecturesService: LecturesService,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly modalService: NgbModal
  ) {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }

  isIrrelevant(): boolean {
    return this.params?.lecture?.status === LectureStatusEnum.IRRELEVANT;
  }

  isPending = (): boolean => {
    if (!this.params.lecture) {
      return false;
    }
    return this.params.lecture?.status === LectureStatusEnum.PENDING;
  }

  isPriorityHigh = (): boolean => {
    if (this.params.lecture?.priority === LecturePriorityEnum.HIGH) {
      return true;
    }
    return false;
  }

  isNotCompleted = (): boolean => {
    if (this.params.lecture?.status === LectureStatusEnum.COMPLETE) {
      return false;
    }
    return true;
  }

  isPaid = (): boolean => {
    if (this.params.lecture?.type === LectureTypeEnum.PAID) {
      return true;
    }
    return false;
  }

  btnSetPaidClicked = (): void => {
    // this.params.debugClickElement(this.params.data);
    this.updateLectureRow('type', LectureTypeEnum.PAID);
  }

  btnSetNonPaidClicked = (): void => {
    this.updateLectureRow('type', LectureTypeEnum.NONPAID);
  }

  btnSetHighPrioClicked = (): void => {
    // this.params.debugClickElement(this.params.data);
    this.updateLectureRow('priority', LecturePriorityEnum.HIGH);
  }

  btnSetNormalPrioClicked = (): void => {
    this.updateLectureRow('priority', LecturePriorityEnum.NORMAL);
  }

  btnApproveClicked = (): void => {
    this.updateLectureRow('status', LectureStatusEnum.UNASSIGNED);
  }

  btnDetailsClicked(): void {
    this.router.navigateByUrl(`lectures/lect/${this.params.lecture?.metadata?.docId}`);
  }

  btnSetUnassignedClicked(): void {
    this.updateLectureRow(
      null, null, {
      status: LectureStatusEnum.UNASSIGNED,
      assigned_uid: null,
      assigned_name: null,
      scheduled_date: null,
      assigned_at: null,
    });
  }

  btnDeleteClicked = (): void => {
    const confirmationModalRef = this.modalService.open(ConfirmationDialogComponent);
    confirmationModalRef.componentInstance.message = 'LECTURES.CONFIRM_DELETE';
    confirmationModalRef.componentInstance.confirmationCallback = () => this.deleteLecture(this.params?.resourceId);
  }

  updateLectureRow = (field?: string,
                      newFieldValue?: LectureStatusEnum | LecturePriorityEnum | LectureTypeEnum,
                      partialLectureUpdate?: Partial<ILecture>,
                      ): void => {
    const lecture = this.params.lecture;
    const origLecture = {
      ...lecture,
    };
    const updatedLecture = { ...lecture, [field]: newFieldValue, ...partialLectureUpdate };
    this.updateLecture(origLecture, updatedLecture, newFieldValue);
  }

  deleteLecture = (resourceId: string): void => {
    this.lecturesService
      .deleteLecture(resourceId)
      .then(() => {
        this.toastr.success(this.translate.instant('UPDATE_LECTURE.DELETE_LECTURE_SUCCESS'));
        const rowNode = this.params.api.getRowNode(this.params.data.metadata.docId);
        this.params.api.applyTransaction({ remove: [rowNode] });
        // this.params?.refresh({
        //   id: resourceId,
        //   action: ActionTypeEnum.DELETED,
        // });
      })
      .catch((error) => {
        console.error(error);
        this.toastr.error(this.translate.instant('UPDATE_LECTURE.DELETE_LECTURE_FAIL'));
      });
  }

  updateLecture = (origLecture: ILecture, updatedLecture: ILecture,
                   value: LectureStatusEnum | LecturePriorityEnum | LectureTypeEnum): void => {
    const metadata = origLecture.metadata;
    this.lecturesService
      .updateLecture(updatedLecture, origLecture)
      .then(() => {
        this.toastr.success(this.translate.instant('UPDATE_LECTURE.UPDATE_LECTURE_SUCCESS'));
        updatedLecture.metadata = metadata;
        const rowNode = this.params.api.getRowNode(this.params.data.metadata.docId);
        rowNode.setData(updatedLecture);
        this.params.api.refreshCells({ force: true, rowNodes: [rowNode]});
        this.params.api.flashCells({ rowNodes: [rowNode] });

        const isFilterStatus = Object.values(LectureStatusEnum).includes(this.params.filter as any);
        const isValueStatus = Object.values(LectureStatusEnum).includes(value as any);
        if (this.params.filter as string !== GeneralEnum.EVERYTHING &&
          ((isFilterStatus && isValueStatus) || (!isFilterStatus && !isValueStatus)) && value !== this.params.filter) {
          // delete row
          this.params.api.applyTransaction({ remove: [rowNode] });
        }

        // this.params?.refresh({
        //   id: metadata.docId,
        //   action: ActionTypeEnum.UPDATED,
        //   value: updatedLecture,
        // });
      })
      .catch((error) => {
        console.error(error);
        this.toastr.error(this.translate.instant('UPDATE_LECTURE.UPDATE_LECTURE_FAIL'));
      });
  }
}
